import Footer from "../components/Footer";
import ThanksImg from "../assets/thanks.webp";
import "./thanks.css";

const Thanks = () => {
  return (
    <>
      <div className="thanks-container">
        <div className="thanks-inner">
          <div className="content">
            <div className="details">
              <h1>Thank You.</h1>
              <p>
                Thank you for reaching out to AmorServ Tech. We have
                received your message and will get back to you as soon as
                possible.
              </p>
            </div>
            <p className="bottom">
              Please check your email for feedback from us shortly.
            </p>
          </div>
          <div className="thanks-img">
            <img src={ThanksImg} alt="Thank you" />
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Thanks;